import { render, staticRenderFns } from "./labelGroup.vue?vue&type=template&id=f8e37a9c&scoped=true"
import script from "./labelGroup.vue?vue&type=script&lang=js"
export * from "./labelGroup.vue?vue&type=script&lang=js"
import style0 from "./labelGroup.vue?vue&type=style&index=0&id=f8e37a9c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8e37a9c",
  null
  
)

export default component.exports